import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import "./styles/common.scss";
import {Alert} from "./components/CommonComponents";
import "firebase/auth";
import {useDispatch, useSelector} from "react-redux";
import CookieConsent, {Cookies} from "react-cookie-consent";
import "./firebase";
import {Routes} from "./routes/main";
import {storeAuthstate} from "./slices/auth";
import {selectDialog} from "./slices/dialog";
import {selectAlert} from "./slices/alert";
import {getMaintenanceListener} from "./api/common";
import {selectAppVersion, selectSiteUnderMaintenance, storeManagement,} from "./slices/management";
import {Dialog} from "./components/Dialog";
import {auth} from "./firebase";
import {Maintenance} from "./pages/Maintenance/main";
import AOS from "aos";
import "aos/dist/aos.css";
import {useTranslation} from "react-i18next";
import FullScreenLoader from "./components/FullScreenLoader/main";
import {finishFullScreenLoading, selectFullScreenLoading, startFullScreenLoading,} from "./slices/loading";
import {useAuthState} from "react-firebase-hooks/auth";
import {getUserListener} from "./api/user";
import {storeUser} from "./slices/profile";
import ErrorReportButton from "./components/ErrorReportButton/main";
import FullScreenVideo from "./components/FullScreenVideo/main";
import {selectVideo} from "./slices/video";

const App = (props: any) => {
    const dialog = useSelector(selectDialog);
    const alert = useSelector(selectAlert);
    const underMaintenance = useSelector(selectSiteUnderMaintenance);
    // const underMaintenance = false;
    const appVersion = useSelector(selectAppVersion);
    const fullScreenLoading = useSelector(selectFullScreenLoading);
    const fullScreenVideo = useSelector(selectVideo);
    const [showRoutes, setShowRoutes] = useState(false);
    const dispatch = useDispatch();
    const topRef = useRef<HTMLDivElement>(null);
    const {t} = useTranslation();
    const [authstate] = useAuthState(auth as any);

    // show loading spinner if user authentication atoms is still loading
    useEffect(() => {
        dispatch(startFullScreenLoading(null));
    }, []);

    // redirect to maintenance page if website is in maintenance
    // reload website if local app version is different from last version
    useEffect(() => {
        if (underMaintenance == null || !appVersion) return;

        const localAppVersion = Cookies.get("appVersion");

        if (localAppVersion !== appVersion) {
            Cookies.set("appVersion", appVersion, {expires: 1000});
            window.location.reload();
            return;
        }
    }, [underMaintenance, appVersion]);

    useEffect(() => {
        AOS.init();
        // ScrollReveal().reveal('.reveal', {distance: '100px', duration: 1500, easing: 'cubic-bezier(.215, .61, .355, 1)', interval: 400});
        const unsubscribe = getMaintenanceListener((doc: any) => {
            dispatch(storeManagement(doc.data()));
        });
        return unsubscribe;
    }, []);

    useEffect(() => {
        if (!authstate) {
            dispatch(finishFullScreenLoading(null));
            setShowRoutes(true);
            return;
        }

        const asToStore = {
            uid: authstate.uid,
            email: authstate.email,
            verified: authstate.emailVerified
        };

        dispatch(storeAuthstate(asToStore));

        const unsubscribe = getUserListener((doc: any) => {
            const user: any = doc.exists ? doc.data() : null;
            if (!user) {

                dispatch(finishFullScreenLoading(null));
                setShowRoutes(true);
                return;
            }

            dispatch(storeUser(user));
            dispatch(finishFullScreenLoading(null));
            setShowRoutes(true);
        });
        return unsubscribe as any;
    }, [authstate]);

    useEffect(() => {
        if (dialog?.Content) document.body.style.overflowY = "hidden";
        else document.body.style.overflowY = "unset";
    }, [dialog]);

    return (
        <div className="app" ref={topRef}>
            {underMaintenance && <Maintenance/>}
            {!underMaintenance && (
                <>
                    <CookieConsent
                        location="bottom"
                        buttonText={t("cookieConsent_btn")}
                        cookieName="cookieConsent"
                        cookieValue={true}
                        acceptOnScroll={true}
                        onAccept={() =>
                            Cookies.set("cookieConsent", true, {expires: 365})
                        }
                        style={{background: "#2B373B"}}
                        buttonStyle={{color: "#4e503b", fontSize: "13px"}}
                        expires={365}
                    >
                        {t("cookieConsent_text") + " "}
                        <Link to="/cookie" style={{color: "#2079F9"}}>
                            {t("cookieConsent_link")}
                        </Link>
                    </CookieConsent>
                    {dialog.Content ? <Dialog {...dialog} topRef={topRef}/> : null}
                    {fullScreenLoading && <FullScreenLoader/>}
                    {fullScreenVideo && <FullScreenVideo video={fullScreenVideo}/>}

                    {showRoutes && <Routes topRef={topRef}/>}
                    {alert.type && <Alert type={alert.type} message={alert.message}/>}
                </>
            )}
        </div>
    );
};

export default App;
